import { render, staticRenderFns } from "./TabPaymentHistory.vue?vue&type=template&id=7aec6014&"
import script from "./TabPaymentHistory.vue?vue&type=script&lang=js&"
export * from "./TabPaymentHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports